import config from "~/temp/config";
import { RestLayoutService } from "@sitecore-jss/sitecore-jss-react";
import { type RestLayoutServiceConfig } from "@sitecore-jss/sitecore-jss/types/layout/rest-layout-service";
import { type CancelTokenSource } from "axios";

interface FetchParams {
  [param: string]: string | number | boolean;
  sc_apikey: string;
  sc_site: string;
  sc_lang: string;
  tracking: boolean;
}

// removes sc_apikey from url
class ClientLayoutService extends RestLayoutService {

	constructor(private options: RestLayoutServiceConfig) {
		super(options);
	}

	protected getFetchParams = (language?: string): FetchParams => {
		const params: Omit<FetchParams, "apiKey"> = {
			sc_site: this.options.siteName,
			sc_lang: language || '',
			tracking: this.options.tracking ?? true,
		};

		if (config.connected) {
			params.sc_apikey = this.options.apiKey;
		}

		return params as FetchParams;
	};
}


export class LayoutServiceFactory {
	create(siteName: string, cancelTokenSource?: CancelTokenSource) {
		return new ClientLayoutService({
			apiHost: config.sitecoreApiHost,
			siteName: siteName,
			apiKey: config.sitecoreApiKey,
			configurationName: "jss",
			cancelTokenSource,
		} as RestLayoutServiceConfig & { cancelTokenSource: CancelTokenSource });
	}
}

export const layoutServiceFactory = new LayoutServiceFactory();
